<template>
    <div :class="$style.icons">
        <SberLogo />
    </div>
</template>

<script>
import SberLogo from "../shapes/SberLogo";

export default {
    name: "SberPaymentBlockIcons",
    components: {
        SberLogo
    },
};
</script>

<style lang="postcss" module>
.icons {
    display: flex;
    margin-top: 0;
    align-items: center;
}

.icons > svg {
    width: 140px;
    height: 55px;
}

.icons > svg:not(:last-child) {
    margin-right: 12px;
}
</style>
